<div class="card-header bg-light">
  <h4 class="card-title mb-0">Avaliação</h4>
</div>
<div class="card-body  wrapper">
  <form [formGroup]="form" #f="ngForm" id="avaliacao-resposta">

    <div class="row p-2">
      <div class="col-12">
        <label class="form-label">Avaliar</label>
      </div>

      <div class="col-auto form-check me-4">
        <input class="form-check-input" type="radio" id="radioAtendido" [value]="1" name="opcao"
               [(ngModel)]="model.statusAvaliacao" [ngModelOptions]="{standalone: true}"
               (change)="controlaStatusAvaliacao()" />
        <label class="form-check-label" for="radioAtendido">Atendido</label>
      </div>

      <div class="col-auto form-check me-4">
        <input class="form-check-input" type="radio" id="radioParcial" [value]="2" name="opcao"
               [(ngModel)]="model.statusAvaliacao" [ngModelOptions]="{standalone: true}"
               (change)="controlaStatusAvaliacao()" />
        <label class="form-check-label" for="radioParcial">Atendido parcialmente</label>
      </div>

      <div class="col-auto form-check">
        <input class="form-check-input" type="radio" id="radioNaoAtendido" [value]="3" name="opcao"
               [(ngModel)]="model.statusAvaliacao" [ngModelOptions]="{standalone: true}"
               (change)="controlaStatusAvaliacao()" />
        <label class="form-check-label" for="radioNaoAtendido">Não atendido</label>
      </div>
    </div>


    <div class="row col-12 p-2">
      <label class="form-label">Comentário </label>
      <textarea type="text" class="form-control" rows="4" formControlName="comentario" maxlength="500"
                [ngClass]="{ 'is-invalid': f.submitted && form.controls['comentario'].invalid} "></textarea>
      <div *ngIf="submitted && form.controls['comentario'].invalid" class="invalid-feedback">
        <div *ngIf="form.controls['comentario'].errors.required">Campo obrigatório</div>
      </div>
    </div>
  </form>
</div>

<div class="card-footer">
  <button type="submit" class="btn btn-success btn-sm mr-1" form="avaliacao-resposta" (click)="salvar()">
    <i class="fas fa-check"></i> Avaliar
  </button>

  <button type="button" class="btn btn-danger btn-sm" (click)="cancelar()">
    <i class="fas fa-times"></i> Cancelar
  </button>
</div>
